import React from "react";
import styled from "styled-components";
import { Row, Col } from "reactstrap";
import { HeaderTitle } from "../../../utils/budget-tool-specific";
import ExperienceGuideList from "./experiences-list"

const Experiences = (props) => {
    return(
        <PageContainer>
            <Row>
                <Col>
                    <HeaderTitle>
                        Welcome
                    </HeaderTitle>
                </Col>
            </Row>
            <ExperienceGuideList client={props.client}/>
        </PageContainer>
    )
}

export default Experiences;

const PageContainer = styled.div`
    padding: 30px 15px;
    height: 100%;
    box-sizing: border-box;
`;